module.exports = __webpack_public_path__ + "img/tk.47f3c635.gif";